<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">警告</div>
      <div class="sub-title">您的账号尚未绑定手机，切换账号后您将无法再次登录此帐号</div>
      <div class="btn-middle" @click='bind'>绑定手机</div>
      <div class="btn-middle" @click='change'>切换账号</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    padding: 30px 0;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 14px;
      color: #3A3A3A;
      /* margin-bottom: 30px; */
      margin: 0 20px 30px 20px;

      @include regular();
    }

    .btn-middle {
      margin: 0 auto 10px;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  import { mapActions } from 'vuex'
  export default {
    props: {
      taskIdGive: ''
    },

    components: {
      Dialog
    },
    mounted () {
      $bus.$on('confirm', () => {
        this.show()
      })
    },
    destroyed () {
      $bus.$off('confirm')
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      },
      bind () {
        this.$refs.p.hide()
        $router.push('/bindMobile')
      },
      change () {
        this.$refs.p.hide()
        $router.push('/swichuser')
      },
      ...mapActions('detail', [
        'giveUpTask'
      ])
    }
  }
</script>
